var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Manage-process-main",class:{ 'Manage-process-main-mobile': _vm.isMobile }},[_c('div',{staticClass:"center"},[_c('Base-title',{attrs:{"title":"整合式创新的管理流程"}}),_c('ManageProcessContent')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }